import React, { useReducer } from 'react';

interface InitialState {
  isMobileMenuOpen: boolean;
}

const initialState: InitialState = {
  isMobileMenuOpen: false,
};

export const GlobalStateContext = React.createContext(initialState);
export const GlobalDispatchContext = React.createContext<React.Dispatch<any>>(() => {});

function reducer(state: InitialState, action: { type: string }) {
  switch (action.type) {
    case 'mobileMenuOpen':
      return { ...state, isMobileMenuOpen: true };
    case 'mobileMenuClosed':
      return { ...state, isMobileMenuOpen: false };
    default:
      throw new Error();
  }
}

const GlobalContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

  const initialState = {
    isMobileMenuOpen: false,
  };

  // The "state" here matches the initialState, until it is changed by the result of the reducer
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <GlobalStateContext.Provider value={state}>
      <GlobalDispatchContext.Provider value={dispatch}>
        {children}
      </GlobalDispatchContext.Provider>
    </GlobalStateContext.Provider>
  );
};

export default GlobalContextProvider;
